module.exports = __webpack_public_path__ + "startpage-746fed5a/anschreiben-aufbau-93d9c9007d593377289be25593fdf4fd.jpeg";